import { Breadcrumb, Button } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";

const breadcrumbNameMap: Record<string, string> = {
  home: "Home",
  creators: "Browse Creators",
  influencers: "Influencers",
  collabs: "Collabs",
  campaigns: "Campaigns",
  applications: "Applications",
  report: "Report",
  messenger: "Messenger",
  settings: "Settings",
  campaign: "Campaign",
  collab: "Collab",
  login: "Login",
};

const humanize = (seg: string) =>
  seg.replace(/-/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

const Breadcrumbs: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const buildBreadcrumb = () => {
    const segments = location.pathname.split("/").filter(Boolean);

    const items: React.ReactNode[] = [];

    // items.push(
    //   <Breadcrumb.Item key="home">
    //     <a
    //       href="/"
    //       onClick={(e) => {
    //         e.preventDefault();
    //         navigate("/");
    //       }}
    //       style={{ color: "#6b7280", fontSize: 14 }}
    //     >
    //       {breadcrumbNameMap.home}
    //     </a>
    //   </Breadcrumb.Item>
    // );

    segments.forEach((seg, idx) => {
      const isLast = idx === segments.length - 1;
      const to = "/" + segments.slice(0, idx + 1).join("/");

      let label = breadcrumbNameMap[seg] || humanize(seg);
      let disabled = false;

      if (
        /^[0-9a-fA-F]{24}$/.test(seg) || // Mongo ObjectId
        /^\d+$/.test(seg) || // numeric id
        /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/.test(
          seg
        ) // UUID
      ) {
        label = "Details";
        if (segments.includes("campaigns")) {
          disabled = true;
        }
      }

      items.push(
        <Breadcrumb.Item key={to}>
          {isLast ? (
            <span
              style={{
                color: "#111827",
                fontWeight: 700,
                fontSize: 20,
                position: "relative",
                top: -3,
              }}
            >
              {label}
            </span>
          ) : disabled ? (
            <span
              style={{
                color: "#6b7280",
                fontSize: 14,
              }}
            >
              {label}
            </span>
          ) : (
            <a
              href={to}
              onClick={(e) => {
                e.preventDefault();
                navigate(to);
              }}
              style={{ color: "#6b7280", fontSize: 14 }}
            >
              {label}
            </a>
          )}
        </Breadcrumb.Item>
      );
    });

    return items;
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 12,
        marginBottom: 8,
      }}
    >
      <Button
        type="default"
        onClick={() => navigate(-1)}
        aria-label="Back"
        style={{
          background: "transparent",
          boxShadow: "none",
          border: "none",
          width: 36,
          height: 36,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: 0,
          position: "relative",
          top: -5,
        }}
      >
        <FontAwesomeIcon icon={faArrowLeft} style={{ color: "#6b7280" }} />
      </Button>
      <Breadcrumb separator={<span style={{ color: "#d1d5db" }}>›</span>}>
        {buildBreadcrumb()}
      </Breadcrumb>
    </div>
  );
};

export default Breadcrumbs;
